import _ from 'lodash';
import CrudPage from '@modules/cruds/CrudPage';
import * as yup from 'yup';
import FormContactData from './ContactDataForm';
import { IConfigComponent } from '@ts/ui-models';

const contacDataSchema = yup.object().shape({
  name: yup.string().required().label('name'),
  contactDataTypeLogicalId: yup.string().required().label('contactDataTypeLogicalId'),
});

const ContactDataPage = props => {
  const defaultValues = {
    entityType: props.data.getIn(['editContactData', 'data', 'entityType']),
    xTypeId: props.data.getIn(['editContactData', 'data', 'xTypeId']),
  };

  const config: IConfigComponent = {
    componentId: 'contactData',
    aclId: 'ContactData',
    crudURL: '/api/contactData',
    fetchURL: '/api/contactData',
  };

  return (
    <CrudPage
      key={'contactDataPage'}
      configComponent={config}
      form={FormContactData}
      defaultValues={defaultValues}
      validationSchema={contacDataSchema}
    />
  );
};

export default ContactDataPage;
